import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import { resetPasswordFetchSuccess, resetPasswordFetchFailure } from './reducer';
import { ResetPasswordResType, ResetPasswordReqDataType } from 'src/types/resetPassword';

const resetPasswordFetchRequest = async (params: ResetPasswordReqDataType) => {
    const res = await api('post', 'api/public/reset-password', params, { withoutExtend: true });
    return res.data;
};

function* resetPasswordFetch(action: { type: string; payload: ResetPasswordReqDataType }) {
    try {
        const response: ResetPasswordResType = yield call((): any => resetPasswordFetchRequest(action.payload));

        yield put(resetPasswordFetchSuccess());
    } catch (error) {
        yield put(resetPasswordFetchFailure({}));
    }
}

export function* resetPasswordFetchWatch() {
    yield takeEvery('resetPassword/resetPasswordFetch', resetPasswordFetch);
}
